import { AiOutlinePhone } from "react-icons/ai"
import { CiLocationOn, CiMail } from "react-icons/ci"

const TopMenu = ()=>{
    return(
        <div className="xl:flex lg:flex md:flex justify-center hidden items-center pb-4 bg-primary">
            <div className=" xl:flex lg:flex md:flex justify-center hidden container pl-8 pr-8 pt-4 text-white font-global_font text-[14px] gap-10">
                <p className="inline-flex items-center gap-1"><span><CiLocationOn className="text-yellow-500 text-[14px]" /></span>C-12,(KSSIDC),KIADB Industrial Area Nanjungud  571302.</p>
                <p className="inline-flex items-center gap-1"><span><CiMail className="text-yellow-500 text-[14px]" /></span>anuoffsetprinters2011@gmail.com</p>
                <p className="inline-flex items-center gap-1"><span><AiOutlinePhone className="text-yellow-500 text-[14px]" /></span>08221-225668, +91 98869 25668 </p>
            </div>
        </div>
    )
}

export default TopMenu